module.exports = __webpack_public_path__ + "static/media/94140036-FKQ0wSgs.eb2081ff.JPG";